export default __webpack_public_path__ + "justhatched-second-screens@2x.17c0019c.png";